import { ReactElement } from 'react'

import { Icon } from 'components/core'

import { IconButton, IconButtonProps } from './IconButton'

function ArrowRightButton(props: IconButtonProps): ReactElement {
    return (
        <IconButton
            icon={<Icon name="ARROW_RIGHT" />}
            size="small"
            {...props}
        />
    )
}

export default ArrowRightButton
